import React from 'react';
import CSSModules from 'react-css-modules';
import FaqGroup from './FaqGroup';
import faqData from './faqData';
import styles from './faq.scss';

@CSSModules(styles, {allowMultiple: true})
class FaqController extends React.Component {

  static propTypes = {
  };

  render() {

    return (
      <div styleName="faq">
        <div styleName="faqHeader">Sunbit FAQs</div>
        <div styleName="faqMain">
          {faqData.map((faqGroup, index) => <FaqGroup key={index} index={index} faqGroup={faqGroup} />)}
        </div>
      </div>
    );
  }
}


export default FaqController;



// WEBPACK FOOTER //
// ./src/faq/FaqController.js